enum Formation {
  STUDENT = 'STUDENT',
  PROFESSIONAL = 'PROFESSIONAL'
}

export default Formation;
